import isoCountryCodeSchema from '@data/schemas/isoCountryCode'
import { ObjectSchema, object, string, number } from 'yup'

const schema: ObjectSchema<TRegistrationUser> = object().shape({
    email: string().email().required(),
    firstName: string().required(),
    id: number().required().positive().integer(),
    lastName: string().required(),
    origin: string().required(),
    residency: string().required(),
    residencyCountryIsoCode: isoCountryCodeSchema.required(),
})

export default schema
